import { render, staticRenderFns } from "./BillingModal.vue?vue&type=template&id=5c6a8819&scoped=true&"
import script from "./BillingModal.vue?vue&type=script&lang=js&"
export * from "./BillingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6a8819",
  null
  
)

export default component.exports